module.exports = "/packs/images/homepage/facilities/trampoline~afc5b5a8c7a84893e0a309ac50cefab6.jpg";